import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ExamSummary, Intake, Patient, ScheduleResponse } from '../models';
import { Api, Session } from '../services/index';
import { SafePipe } from '../components/safeHtml.component';


@Component({
  selector: 'app-bh-screen-expect',
  templateUrl: './bh-screen-what-to-expect.html'
})

export class BHScreenWhatToExpect implements OnInit {

  loadingSSO: boolean = false;
  patientId: number;
  samlData: string = '';
  errorMsg: string;
  private myTemplate: any = "";
  constructor(private api: Api,
    private route: ActivatedRoute,
    private router: Router,
    private session: Session
  ) {
    this.errorMsg = '';
  }

  ngOnInit() {
    
  }

 

  

  continue() {

    //US688
    this.loadingSSO = true;
    this.errorMsg = '';
    /*  
    //local debug todo comment this out for deploy. 
    let ssoRequest = this.api.getBHScreenSSO(-1); 
    ssoRequest.subscribe(response => {
      this.loadingSSO = false;
      console.log('response:', response);

      if (response.hasOwnProperty('error')) { 
        console.log('ERROR:', response.error);
        this.error =  response.error;
        this.loadingSSO = false;
        return;
      }
      console.log('posting saml:', response.samlResponse);
    }, (err:any) => {
      let errMsg = JSON.parse(err._body);
      this.error = errMsg.message;
      this.loadingSSO = false;
    });
  */
    //todo uncoment this for deploy

    let url = this.session.environment.settings.mdlogixSSO + "/#/redirect?sid=" + this.session.jwtToken + "&iid=" + -1;
    console.log('URL:', url);
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = url;
    this.router.navigate(['/dashboard']); //INTAKE ID IS -1 SINCE SCREENING DOESN'T REQUIRE AN INTAKE


  }
}
